/**
 * Canonical pathway URLs for public vs authenticated shells.
 *
 * Authenticated learners must stay inside `/app/*` so the sidebar chrome does
 * not disappear when opening a pathway from Browse. Public marketing and
 * shareable links keep `/learn/:slug`.
 */

export function pathwayDetailPath(slug: string, inAppShell = false): string {
  return inAppShell ? `/app/pathways/${slug}` : `/learn/${slug}`;
}

export function pathwayModulePath(slug: string, moduleId: string, inAppShell = false): string {
  return inAppShell
    ? `/app/pathways/${slug}/module/${moduleId}`
    : `/learn/${slug}/module/${moduleId}`;
}

/** The learner's private progression view for a pathway. */
export function learnerJourneyPath(slug: string, inAppShell = false): string {
  return inAppShell ? `/app/pathways/${slug}/journey` : `/learn/${slug}/journey`;
}

export function pathwayCatalogPath(inAppShell = false): string {
  return inAppShell ? "/app/browse" : "/learn";
}

/**
 * Pricing deep-link for legacy `/pricing` and retired cert-checkout URLs.
 *
 * Product decision (2026-08-11): pathway-scoped, not BGMI-only.
 * - Known game slug → that game's marketing landing `#pricing`
 * - Bare `/pricing` (no slug) → neutral catalog `/learn`
 * - Unknown slug → pathway detail (prices live on the enroll card)
 */
export function pricingLandingHref(slug?: string | null): string {
  if (!slug) return "/learn";
  if (slug.startsWith("bgmi")) return "/bgmi#pricing";
  if (slug.startsWith("free-fire")) return "/free-fire#pricing";
  return pathwayDetailPath(slug, false);
}

/** True when the current route is rendered under the authenticated AppLayout. */
export function isAppShellPath(pathname: string): boolean {
  return pathname === "/app" || pathname.startsWith("/app/");
}

